import script from "./ShoesListOne.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoesListOne.vue?vue&type=script&setup=true&lang=js"

import "./ShoesListOne.vue?vue&type=style&index=0&id=6ed923c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed923c5"]])

export default __exports__